export default (theme) => ({
    errorText: {
        color: theme.custom.red,
        fontSize: 12,
        fontWeight: 'bold',
        margin: '8px 0px 0px 8px',
    },
});
